import { ProductType } from '@inter-ikea-storageone/range';
import { hideDoors } from 'ducks/layout';
import removeAllInteriorsFromSelectedFrame from 'rangeConfig/shared/behaviors/removeAllInteriorsFromSelectedFrame';
import { noProductsWithTypesForSelectedEntity } from 'rangeConfig/shared/rules/noneOptionSelectedRules';

export const noneOptionForInteriorSuggestions = {
  behaviors: {
    removeProducts: [removeAllInteriorsFromSelectedFrame],
    productClicked: [hideDoors]
  },
  selected: noProductsWithTypesForSelectedEntity([
    ProductType.PAX_DRAWER,
    ProductType.PAX_DRAWER_FRAMED,
    ProductType.PAX_DRAWER_FRAMED_GLASS,
    ProductType.PAX_DRAWER_LOCKABLE,
    ProductType.PAX_GLASS_DRAWER,
    ProductType.PAX_SHELF,
    ProductType.PAX_GLASS_SHELF,
    ProductType.PAX_PULL_OUT_TRAY,
    ProductType.PAX_PULL_OUT_TRAY_WITH_DIVIDER_INSERTS_ASM,
    ProductType.PAX_PULL_OUT_TRAY_WITH_MAT_ASM,
    ProductType.PAX_PULL_OUT_TRAY_WITH_COMPARTMENT_INSERTS_ASM,
    ProductType.PAX_PULL_OUT_TRAY_WITH_SHOE_INSERTS_ASM,
    ProductType.PAX_CLOTH_RAIL_350,
    ProductType.PAX_CLOTH_RAIL_580,
    ProductType.PAX_VALET_HANGER,
    ProductType.PAX_T_DIVIDER,
    ProductType.PAX_L_DIVIDER,
    ProductType.PAX_PULL_OUT_MULTI_USE_HANGER,
    ProductType.PAX_PULL_OUT_TROUSER_HANGER,
    ProductType.PAX_PULL_OUT_CLOTH_RAIL,
    ProductType.PAX_SHOE_SHELF,
    ProductType.PAX_PULL_OUT_SHOE_SHELF,
    ProductType.PAX_MESH_BASKET_ASM,
    ProductType.PAX_METAL_BASKET_ASM,
    ProductType.PLATSA_CLOTH_RAIL_40,
    ProductType.PLATSA_CLOTH_RAIL_55,
    ProductType.PLATSA_SHELF,
    ProductType.PLATSA_SHOE_SHELF,
    ProductType.PLATSA_WIRE_BASKET_ASM,
    ProductType.PLATSA_WIRE_BASKET_RAIL,
    ProductType.PLATSA_WIRE_BASKET,
    ProductType.PLATSA_MULTIUSE_HANGER,
    ProductType.SMASTAD_SHELF,
    ProductType.SMASTAD_CLOTH_RAIL_ASM,
    ProductType.SMASTAD_CLOTH_RAIL_55_W_HOOKS_ASM,
    ProductType.SMASTAD_CLOTH_RAIL_40,
    ProductType.SMASTAD_WIRE_BASKET_ASM,
    ProductType.SMASTAD_RAIL_STRIP_W_HOOKS_ASM,
    ProductType.IVAR_BOTTLE_RACK,
    ProductType.IVAR_CABINET,
    ProductType.IVAR_SHELF_FELT,
    ProductType.IVAR_SHELF_PINE,
    ProductType.IVAR_SHELF_METAL,
    ProductType.IVAR_DRAWER_PINE,
    ProductType.IVAR_STORAGE_BOX,
    ProductType.IVAR_TABLE,
    ProductType.JONAXEL_CLOTH_RAIL_ADJUSTABLE,
    ProductType.JONAXEL_FRAME_SHELF,
    ProductType.JONAXEL_MESH_BASKET,
    ProductType.JONAXEL_TOP_SHELF,
    ProductType.JONAXEL_WIRE_BASKET
  ]),
  title: 'storageone.productListNoInteriorsOptionTitle',
  subtitle: 'storageone.productListNoInteriorsSubtitle'
} as any;
